import { getAuthToken } from "./auth";

export async function authedFetch(
    input: RequestInfo | URL,
    init?: RequestInit
): Promise<Response> {
    const token = getAuthToken();
    const headers = new Headers(init?.headers);
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return fetch(input, { ...init, headers });
}
